import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const MainModel = ({
  header,
  openVar,
  children,
  buttonTitle,
  buttonFunc,
  closeFunc,
  isLoading = false,
  size = "4xl",
  extraButtons,
  hideDefaultFooter = false,
}) => {
  const { onClose } = useDisclosure();

  return (
    <Modal
      isOpen={openVar}
      onClose={onClose}
      closeOnOverlayClick={true}
      size={size}
    >
      <ModalOverlay />
      <ModalContent bg="white">
        <ModalHeader>{header}</ModalHeader>
        <ModalBody maxH={hideDefaultFooter ? "80vh" : undefined} overflowY={hideDefaultFooter ? "auto" : undefined}>
          {children}
        </ModalBody>
        {!hideDefaultFooter && (
          <ModalFooter justifyContent="center" flexDirection="column" gap={4}>
            {extraButtons && extraButtons}
            {buttonTitle && (
              <Button
                isLoading={isLoading}
                onClick={() => buttonFunc()}
                color="white"
                bg="main_1"
                _focus={{ outline: "none" }}
                minW="200px"
                type="submit"
              >
                {buttonTitle}
              </Button>
            )}
            <Button
              onClick={closeFunc}
              color="main_1"
              variant="outline"
              bg="transparent"
              _hover={{ outline: "none", bg: "transparent" }}
              _focus={{ outline: "none", bg: "transparent" }}
              minW="200px"
            >
              الغاء
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default MainModel;
